import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_auth_form = _resolveComponent("auth-form")!
  const _component_password_reset = _resolveComponent("password-reset")!

  return ($setup.isAuth)
    ? (_openBlock(), _createBlock(_component_loader, { key: 0 }))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        (!$setup.isResetForm)
          ? (_openBlock(), _createBlock(_component_auth_form, {
              key: 0,
              onChangeForm: $setup.changeForm
            }))
          : (_openBlock(), _createBlock(_component_password_reset, {
              key: 1,
              info: $setup.phone,
              "is-main": true,
              onChangeForm: $setup.changeForm
            }, null, 8, ["info"]))
      ], 64))
}